import React from "react";
import { useTranslation } from "react-i18next";
import { MultimediaCategory } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import MultimediaCategoryForm from "../MultimediaCategoryForm";

type Props = {
  category?: MultimediaCategory;
  isOpen: boolean;
  isSubmitting: boolean;
  defaultOrderNumber: number | null;
  onClose: () => void;
  onSubmit: (data: MultimediaCategory) => void;
};

const MultimediaCategoryModal: React.FC<Props> = ({
  category,
  isOpen,
  isSubmitting,
  defaultOrderNumber,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {category
            ? t("components.categoryModal.typeEdit")
            : t("components.categoryModal.typeNew")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <MultimediaCategoryForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => onSubmit(data)}
          defaultOrderNumber={defaultOrderNumber}
          onCancel={onClose}
          category={category}
        />
      </ModalBody>
    </Modal>
  );
};

export default MultimediaCategoryModal;
